const COLLECTION_LABELS = {
  hazirbeton_mikser_sevkiyat: "Mikser Sevkiyatları",
  hazirbeton_pompa_hakedis: "Pompa Hakedişleri",
  hazirbeton_zone_uretim: "Zone Üretimleri",
  fuel_transactions: "Yakıt Hareketleri",
  fuel_deliveries: "Yakıt Alımları",
  kazalar: "Kaza Kayıtları",
  issues: "Arıza ve Talep Kayıtları",
  faturalar: "Faturalar",
  plates: "Araç Kartları",
  personeller: "Personel Kartları",
  mazot_fiyatlari: "Mazot Fiyatları"
};

const FIELD_LABELS = {
  ad: "Ad",
  soyad: "Soyad",
  adSoyad: "Ad Soyad",
  aktif: "Aktif",
  aracCinsi: "Araç Cinsi",
  baslik: "Başlık",
  baglantiAlani: "Eşleşme Alanı",
  bomUzunlugu: "Bom Uzunluğu",
  "bomUzunluğu": "Bom Uzunluğu",
  carpanAlan: "Çarpan Alan",
  cikisKm: "Çıkış Km",
  date: "Tarih",
  deleted: "Silindi",
  donusKm: "Dönüş Km",
  driverId: "Sürücü ID",
  driverName: "Sürücü Adı",
  etiket: "Etiket",
  fiiliKm: "Fiili Km",
  fiiliM3: "Fiili m3",
  gorev: "Görev",
  hedefAlan: "Hedef Alan",
  irsaliyeNo: "İrsaliye No",
  katsayi: "Katsayı",
  kilometre: "Kilometre",
  km: "Km",
  liters: "Litre",
  m3: "Toplam m3",
  mikserCikisSaat: "Mikser Çıkış Saati",
  mikserDonusSaat: "Mikser Dönüş Saati",
  mikserFirmasi: "Mikser Firması",
  mikserPlaka: "Mikser Plaka",
  mikserSure: "Mikser Süre",
  musteriAdi: "Müşteri",
  odometerKm: "Kilometre",
  operator: "Operatör",
  operatorAdi: "Operatör",
  personelAdi: "Personel",
  personelGorevi: "Görev",
  plaka: "Plaka",
  plate: "Plaka",
  pompaFirmasi: "Pompa Firması",
  pompaPlaka: "Pompa Plaka",
  receiptNo: "Fiş No",
  santiyeAdi: "Şantiye",
  seferSayisi: "Sefer Sayısı",
  "Sefer Sayısı": "Sefer",
  silindi: "Silindi",
  soforAdi: "Sürücü",
  sourceType: "Kaynak Tipi",
  status: "Durum",
  tarih: "Tarih",
  teslimSekli: "Teslim Şekli",
  tesis: "Tesis",
  Tesis: "Tesis",
  "Tesis_Adı": "Tesis",
  uretimM3_zone: "Üretim m3",
  vehiclePlate: "Araç Plaka",
  vehicleTesis: "Araç Tesisi",
  vehicleType: "Kullanım",
  vehicleUsage: "Kullanım",
  kullanim: "Kullanım",
  votoKm: "Voto Km",
  yagciAdi: "Yağcı",
  "Gün": "Gün",
  "Hafta": "Hafta",
  "Hakediş": "Hakediş Tutarı",
  "Toplam KM": "Toplam KM"
};

const splitWords = (value) => {
  return String(value || "")
    .replace(/_/g, " ")
    .replace(/([a-zçğıöşü])([A-ZÇĞİÖŞÜ])/g, "$1 $2")
    .replace(/\s+/g, " ")
    .trim();
};

const titleCaseTr = (value) => {
  return splitWords(value)
    .split(" ")
    .map(word => {
      if (!word) return word;
      if (/^(m3|km|id)$/i.test(word)) return word.toLocaleUpperCase("tr-TR");
      return word.charAt(0).toLocaleUpperCase("tr-TR") + word.slice(1);
    })
    .join(" ");
};

export const getCollectionLabel = (collectionName) => {
  return COLLECTION_LABELS[collectionName] || titleCaseTr(collectionName);
};

export const getFieldLabel = (fieldName) => {
  if (!fieldName) return "";
  if (String(fieldName).startsWith("Hakediş - ")) return fieldName;
  return FIELD_LABELS[fieldName] || titleCaseTr(fieldName);
};

export const getFieldPathLabel = (path) => {
  if (!path) return "";
  const parts = String(path).split(".");
  if (parts.length === 1) return getFieldLabel(path);
  const collectionName = parts.shift();
  return `${getCollectionLabel(collectionName)} > ${getFieldLabel(parts.join("."))}`;
};
